import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { useMapped } from "@omni/utils/context/mapped.context";

import { useColorsContext } from "@/components/PaintConfigurator/components/colors/context/colors.context";

import { useFamiliesContext } from "../../context/families.context";
import { NoColorsFound } from "./components/noColorsFound/noColorsFound";
import { ColorListContextProvider } from "./context/colorsList.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { families } = useFamiliesContext();
    const { families: outerFamilies } = useColorsContext();
    const { index } = useMapped();

    const familyEntry = [...families.entries()].at(index);
    if (!familyEntry) return null;

    const [familyId, colors] = familyEntry;

    const family = outerFamilies.find((f) => f.id === familyId);

    if (!family || !colors || colors.length === 0) {
        return <NoColorsFound />;
    }

    return (
        <ColorListContextProvider
            family={family}
            colors={colors}
        >
            {children}
        </ColorListContextProvider>
    );
};

export { Base };
